import { Module } from "plugins/_application";

var $ = jQuery;

export default class NavSearch extends Module {

	ready(app) {

        this.SEARCH_ICON = document.getElementById('navigation-search');
        this.SEARCH_WRAP = document.getElementById('navigation-search-wrap');

        this.cls = 'nav-search-wrap--open';

        if (!this.SEARCH_ICON && !this.SEARCH_WRAP) {
            return;
        }

        this.eventListeners();

    }

    eventListeners() {

        // click on icon
        this.SEARCH_ICON.addEventListener('click', this.toggleSearch.bind(this));

        // close on escape
        window.addEventListener('keydown', () => {
            event.keyCode === 27 ? this.closeSearch() : '';
        });

        // close on scroll
        window.addEventListener('scroll', this.closeSearch.bind(this));

    }

    toggleSearch() {
        this.SEARCH_WRAP.classList.contains( this.cls ) ?  this.closeSearch() : this.openSearch();
    }

    openSearch() {
        this.SEARCH_WRAP.classList.add( this.cls );

        const SEARCH_INPUT = this.SEARCH_WRAP.querySelector('input');
        if (SEARCH_INPUT) {
            SEARCH_INPUT.focus();
        }
    }

    closeSearch() {
        this.SEARCH_WRAP.classList.remove( this.cls );
    }
}